




import Vue from "vue";
export default Vue.extend ({
mounted() {
    document.addEventListener("DOMContentLoaded", this.oneTrustCookieSetting);
  },
  methods: {
    handleDisclaimer() {
      //@ts-ignore
      this.$store.state.showLongDisclaimer = !this.$store.state.showLongDisclaimer;
    },
    oneTrustCookieSetting(): void {
      setTimeout(function () {
        let cookieLink = document.querySelector(".cookies-link");
        const popupOpenButton = document.querySelector(".ot-floating-button__open");
        if (cookieLink && popupOpenButton) {
          cookieLink.addEventListener("click", function (event) {
            event.preventDefault();
            console.error('test')
            let clickEvent = new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            });
            popupOpenButton.dispatchEvent(clickEvent);
          });
        }
      }, 2000);
    },
  },
})
